const { COUNTRY } = require('@src/constants');

const checkVietNam = () => {
  const country = localStorage.getItem('country');
  const isVietNam = country === COUNTRY.VN || !country;
  return isVietNam;
};

export { checkVietNam };
